import React from 'react'

import { ListItemActionSDUI } from './ListItemActionSDUI'
import { ListItemSDUIRendererBase } from '../hooks/ListItemSDUIRendererBase'
import type { SDUIComponentProps } from '../interfaces'

interface ListItemActionSDUIRendererProps {
  sduiComponent: SDUIComponentProps
}

export const ListItemActionSDUIRenderer: React.FC<ListItemActionSDUIRendererProps> = ({
  sduiComponent,
}) => (
  <ListItemSDUIRendererBase
    sduiComponent={sduiComponent}
    inlineItems={(sduiComponent.props?.items ?? []) as ListItemActionData[]}
    Component={ListItemActionSDUI}
  />
)
